import { render, staticRenderFns } from "./StackRouterHeaderBar.vue?vue&type=template&id=171ae754&scoped=true"
import script from "./StackRouterHeaderBar.vue?vue&type=script&lang=js"
export * from "./StackRouterHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./StackRouterHeaderBar.vue?vue&type=style&index=0&id=171ae754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ae754",
  null
  
)

export default component.exports